<template>
  <div>
    <a-spin :spinning="loadingData">
      <div class="neo-tabs-classes">
        <a-tabs
          :defaultActiveKey="selectedClass"
          :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'"
          @change="handleClassChange"
        >
          <a-tab-pane :key="0">
            <span slot="tab">
              Select Class
            </span>

            <div class="">
              <p class="font-weight-bold text-primary">
                Select a class to manage final results settings!
              </p>
            </div>
          </a-tab-pane>
          <a-tab-pane v-for="setting in data" :key="setting.id">
            <span slot="tab"> Class: {{ setting.name }} </span>
            <final-result-setting-form
              :settingData="setting"
              :session="session"
              :classId="selectedClass"
              @saved="handleSettingsSaved"
              @loaded="handleDataLoaded"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import FinalResultSettingForm from '@/components/bosemexam/final/Form/index'

export default {
  name: 'FinalResultListTable',
  components: {
    FinalResultSettingForm,
  },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    session: Number,
  },
  data: function() {
    return {
      loadingData: false,
      selectedClass: 0,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    moment,
    handleClassChange(classId) {
      // this.loadingData = true
      this.selectedClass = classId
      if (classId === 0) {
        this.loadingData = false
      }
    },
    handleSettingsSaved() {
      this.$emit('updateTable')
    },
    handleDataLoaded() {
      this.loadingData = false
    },
  },
}
</script>
